import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router";
import { DataList, PageHeader, StatusPill, type DataListColumn } from "@ozpanel/kit";
import { useModules, type ModuleRow } from "../modules";

const healthTone = (h: string) =>
  h === "healthy" ? "ok" : h === "degraded" ? "warn" : h === "critical" ? "bad" : "neutral";

const columns: DataListColumn<ModuleRow>[] = [
  { key: "title", label: "Module", sortable: true, value: (r) => r.manifest.title },
  { key: "name", label: "Name", sortable: true, value: (r) => r.manifest.name },
  { key: "category", label: "Category", sortable: true, value: (r) => r.manifest.category || "—" },
  { key: "owner", label: "Owner", sortable: true, value: (r) => r.manifest.owner || "host" },
  {
    key: "health",
    label: "Health",
    sortable: true,
    value: (r) => r.health,
    render: (r) => <StatusPill tone={healthTone(r.health)}>{r.health}</StatusPill>,
  },
];

export function ModulesScreen() {
  const api = useModules();
  const modules = useQuery({ queryKey: ["modules"], queryFn: api.list });
  const navigate = useNavigate();

  return (
    <div>
      <PageHeader
        title="Modules" subtitle={
          modules.data
            ? `${modules.data.total} registered — the same registry the navigation is built from`
            : undefined
        }
      />
      <DataList
        items={modules.data?.items ?? []}
        columns={columns}
        getRowKey={(r) => r.manifest.name}
        onRowClick={(r) => navigate(`/modules/${r.manifest.name}`)}
        searchable
        searchPlaceholder="Search modules…" loading={modules.isLoading}
        error={modules.error}
        errorContext="the module registry" />
    </div>
  );
}
